import React, { useState, useEffect, useCallback } from 'react';
import { localToday } from '../../utils/dateUtils';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import { useEducation } from '../../context/educationContext';
import Modal from '../../components/modal';
import { toast } from 'react-toastify';
import PlusCircle from '../../assets/icons/pluscircle.svg';
import QuickAddModal from '../../components/modal/quickAddModal';
import useSubmitLock from '../../utils/useSubmitLock';
import ReactPaginate from 'react-paginate';

const Discipline = () => {
  const { listSubjects, createSubject, listTypeSubjects, createTypeSubject, listClasses, listCourses, listTeachers } = useEducation();
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  const [subjects, setSubjects] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    date: localToday(),
    workload_hours: '',
    workload_minutes: '',
    type_subject: '',
    education_class: '',
    course: '',
    teacher: '',
  });

  const [typeSubjects, setTypeSubjects] = useState([]);
  const [classes, setClasses] = useState([]);
  const [courses, setCourses] = useState([]);
  const [teachers, setTeachers] = useState([]);

  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoadingSubjects, setIsLoadingSubjects] = useState(true);

  const fetchSubjects = useCallback(async () => {
    setIsLoadingSubjects(true);
    try {
      const offset = currentPage * itemsPerPage;

      const response = await listSubjects({
        limit: itemsPerPage,
        offset,
      });

      const normalized = Array.isArray(response?.results) ? response.results : [];

      setSubjects(normalized);
      setTotalItems(typeof response?.count === 'number' ? response.count : normalized.length);
    } catch (err) {
      console.error('Erro ao carregar disciplinas:', err);
      setSubjects([]);
      setTotalItems(0);
    } finally {
      setIsLoadingSubjects(false);
    }
  }, [listSubjects, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchSubjects();
  }, [fetchSubjects]);

  useEffect(() => {
    const fetchAllPages = async (fn) => {
      try {
        const response = await fn({ limit: 1000, offset: 0 });
        return response?.results || [];
      } catch (error) {
        console.error('Erro ao buscar lista completa:', error);
        return [];
      }
    };

    const fetchData = async () => {
      try {
        const typeRes = await fetchAllPages(listTypeSubjects);
        setTypeSubjects(typeRes);

        const classRes = await fetchAllPages(listClasses);
        setClasses(classRes);

        const courseRes = await fetchAllPages(listCourses);
        setCourses(courseRes);

        const teacherRes = await fetchAllPages(listTeachers);
        setTeachers(teacherRes);
      } catch (err) {
        console.error('Erro ao carregar dados adicionais:', err);
      }
    };

    fetchData();
  }, [
    listTypeSubjects,
    listClasses,
    listCourses,
    listTeachers
  ]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      try {
        const formattedWorkload = `${String(formData.workload_hours || 0).padStart(2, '0')}:${String(formData.workload_minutes || 0).padStart(2, '0')}:00`;
        const payload = {
          date: formData.date,
          workload: formattedWorkload,
          type_subject: Number(formData.type_subject),
          education_class: Number(formData.education_class),
          course: Number(formData.course),
          teacher: formData.teacher,
        };
        await createSubject(payload);
        setIsModalOpen(false);
        const updated = await listSubjects();
        setSubjects(updated.results || []);
        setFormData({
          date: localToday(),
          workload_hours: '',
          workload_minutes: '',
          type_subject: '',
          education_class: '',
          course: '',
          teacher: '',
        });
      } catch (err) {
        console.error('Erro ao cadastrar disciplina:', err);
        toast.error('Erro ao cadastrar disciplina');
      }
    });
  };

  // Função para adicionar Tipo de Matéria via QuickAddModal
  const handleAddTypeSubject = async (name) => {
    try {
      await createTypeSubject({ name });
      const updated = await listTypeSubjects();
      setTypeSubjects(updated?.results || []);
    } catch (err) {
      console.error('Erro ao adicionar Tipo de Matéria:', err);
      toast.error('Erro ao adicionar Tipo de Matéria');
    }
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container">
        <Titulo
          children={<h2>Disciplinas</h2>}
          children2={
            <button className="btnAdcionar" onClick={() => setIsModalOpen(true)}>
              <img src={PlusCircle} alt='icone' /> Cadastrar Disciplina
            </button>
          }
        />

        <div className="content content-table ">
          <table className="tabela">
            <thead>
              <tr>
                <th>Data</th>
                <th>Carga Horária</th>
                <th>Tipo</th>
                <th>Turma</th>
                <th>Curso</th>
                <th>Professor</th>
              </tr>
            </thead>
            {isLoadingSubjects ? (
              <tbody>
                <tr>
                  <td colSpan="6">Carregando...</td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {subjects.length > 0 ? (
                  subjects.map((subject) => (
                    <tr key={subject.id}>
                      <td>{new Date(subject.date).toLocaleDateString()}</td>
                      <td>{subject.workload}</td>
                      <td>{subject.type_name}</td>
                      <td>{subject.education_class ? subject.education_class : 'Não informado'}</td>
                      <td>{subject.course ? subject.course : 'Não informado'}</td>
                      <td>{subject.teacher_name}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">Nenhuma disciplina encontrada.</td>
                  </tr>
                )}
              </tbody>
            )}
          </table>
          {!isLoadingSubjects && (
            <div className="pagination-options">
              <div>
                <label htmlFor="itemsPerPage">Disciplinas por página:</label>
                <select
                  id="itemsPerPage"
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                >
                  <option value={10}>10</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>

              <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={Math.ceil(totalItems / itemsPerPage)}
                pageRangeDisplayed={3}
                marginPagesDisplayed={1}
                onPageChange={handlePageClick}
                containerClassName={'pagination'}
                activeClassName={'activeNumber'}
                previousClassName={'prev'}
                nextClassName={'next'}
                pageClassName={'page'}
                breakClassName={'break-me'}
              />
            </div>
          )}
        </div>

        {isModalOpen && (
          <Modal
            isOpen={isModalOpen}
            closeModal={() => {
              setIsModalOpen(false);
              setFormData({
                date: localToday(),
                workload_hours: '',
                workload_minutes: '',
                type_subject: '',
                education_class: '',
                course: '',
                teacher: '',
              });
            }}
          >
            <h4>Cadastrar Disciplina</h4>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Data</label>
                <input type="date" name="date" value={formData.date} onChange={handleInputChange} required />
              </div>
              <div className="form-group">
                <label>Carga Horária</label>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <input
                    type="number"
                    name="workload_hours"
                    value={formData.workload_hours || ''}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, workload_hours: e.target.value }))
                    }
                    placeholder="Horas"
                    min={0}
                    required
                  />
                  <input
                    type="number"
                    name="workload_minutes"
                    value={formData.workload_minutes || ''}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, workload_minutes: e.target.value }))
                    }
                    placeholder="Minutos"
                    min={0}
                    max={59}
                  />
                </div>
              </div>

              <div className="form-group container-quick-modal">
                <div className="form-group-lager">
                  <label>Tipo de Matéria</label>
                  <select name="type_subject" value={formData.type_subject} onChange={handleInputChange} required>
                    <option value="">Selecione o tipo</option>
                    {typeSubjects.map((type) => (
                      <option key={type.id} value={type.id}>{type.name}</option>
                    ))}
                  </select>
                </div>
                <QuickAddModal
                  label="Tipo de Matéria"
                  fields={[
                    { name: 'name', placeholder: 'Nome do tipo', type: 'text' },
                  ]}
                  onAdd={async (data) => await handleAddTypeSubject(data.name)}
                />
              </div>

              <div className="form-group">
                <label>Turma</label>
                <select name="education_class" value={formData.education_class} onChange={handleInputChange} required>
                  <option value="">Selecione a turma</option>
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>{cls.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Curso</label>
                <select name="course" value={formData.course} onChange={handleInputChange} required>
                  <option value="">Selecione o curso</option>
                  {courses.map((course) => (
                    <option key={course.id} value={course.id}>{course.name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Professor</label>
                <select name="teacher" value={formData.teacher} onChange={handleInputChange} required>
                  <option value="">Selecione o professor</option>
                  {teachers.map((teacher) => (
                    <option key={teacher.id} value={teacher.id}>{teacher.name}</option>
                  ))}
                </select>
              </div>
              <button type="submit" className="btnAcao" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Salvar'}
              </button>
            </form>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default Discipline;
